<template>
  <v-container>
    <v-row
      ><v-col cols="0" lg="1"></v-col
      ><v-col cols="12" lg="12" xl="10">
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="desserts"
          :single-select="singleSelect"
          :sort-desc="false"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          :search="search"
          item-key="cityName"
          :items-per-page="-1"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>熱門店家</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-dialog persistent v-model="dialog" max-width="960px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="blue-grey"
                    dark
                    class="mb-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    新增
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                </template>
                <v-card>
                  <v-toolbar color="primary" dark>
                    <v-toolbar-title>{{ formTitle }}</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn icon @click="dialog = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>

                  <v-card-text class="pt-6">
                    <v-container>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-row>
                          <!--<v-col cols="12" md="6">
                          <v-text-field
                            v-model="template.cityId"
                            label="cityId"
                            hide-details="true"
                            dense
                            outlined
                            required
                          ></v-text-field> </v-col
                        >--><v-col cols="12" md="12">
                            <v-text-field
                              v-model="template.storeNo"
                              label="*商店編號"
                              hide-details="true"
                              dense
                              outlined
                              required
                              :rules="[(v) => !!v]"
                              @input="debouncedFetchStoreInfo"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" v-if="storeInfo">
                            <v-card class="pa-2" outlined>
                              <v-row>
                                <v-col cols="12" md="4">
                                  <v-img
                                    :src="storeInfo.mainPictureUrl"
                                    aspect-ratio="1.5"
                                    height="182"
                                    class="d-none d-md-block"
                                    contain
                                  >
                                    <template v-slot:placeholder>
                                      <v-row
                                        class="fill-height ma-0"
                                        align="center"
                                        justify="center"
                                      >
                                        <v-progress-circular
                                          indeterminate
                                          color="grey lighten-5"
                                        />
                                      </v-row>
                                    </template>
                                  </v-img>
                                  <v-img
                                    :src="storeInfo.mainPictureUrl"
                                    aspect-ratio="1.5"
                                    class="d-block d-md-none"
                                    cover
                                  >
                                    <template v-slot:placeholder>
                                      <v-row
                                        class="fill-height ma-0"
                                        align="center"
                                        justify="center"
                                      >
                                        <v-progress-circular
                                          indeterminate
                                          color="grey lighten-5"
                                        />
                                      </v-row>
                                    </template>
                                  </v-img>
                                </v-col>
                                <v-col cols="12" md="8">
                                  <div>
                                    <strong>商店名稱：</strong
                                    >{{ storeInfo.storeName }}
                                  </div>
                                  <div>
                                    <strong>活動名稱：</strong
                                    >{{ storeInfo.title }}
                                  </div>
                                  <!-- <div>
                                    <strong>介紹：</strong>{{ storeInfo.description }}
                                  </div> -->
                                  <div>
                                    <strong>地址：</strong
                                    >{{ storeInfo.address }}
                                  </div>
                                  <div>
                                    <strong>電話：</strong>{{ storeInfo.phone }}
                                  </div>
                                  <div>
                                    <strong>起始日期：</strong
                                    >{{ storeInfo.startDate }}
                                  </div>
                                  <div>
                                    <strong>結束日期：</strong
                                    >{{ storeInfo.endDate }}
                                  </div>
                                  <div>
                                    <strong>狀態：</strong
                                    >{{ storeInfo.expired ? "過期" : "未過期" }}
                                  </div>
                                  <div>
                                    <strong>顯示：</strong
                                    >{{ storeInfo.display ? "顯示" : "隱藏" }}
                                  </div>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">
                      取消
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="save">
                      儲存
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                  <v-card-title class="text-h5"
                    >確定要移除<span
                      class="d-inline-block mx-2"
                      style="color: #ff5252"
                      >storeNo.{{ template.storeNo }}</span
                    >
                    ?</v-card-title
                  >
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete"
                      >取消</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                      >確認</v-btn
                    >
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:[`item.storeId`]="{ item }">
            {{ item.storeId + 1 }}
          </template>
          <template v-slot:[`item.actionsEdit`]="{ item }">
            <v-icon @click="editItem(item)" style="font-size: 19px">
              mdi-pencil
            </v-icon>
            <!--<v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>-->
          </template>
          <template v-slot:[`item.actionsDel`]="{ item }">
            <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
          </template>
        </v-data-table></v-col
      ><v-col cols="0" lg="1"></v-col
    ></v-row>
  </v-container>
</template>

<script>
import { db } from "@/firebase";
import {
  query,
  where,
  collection,
  getDoc,
  getDocs,
  setDoc,
  doc,
  updateDoc,
  arrayUnion,
  arrayRemove,
  // deleteDoc,
} from "firebase/firestore/lite";

export default {
  data: () => ({
    valid: true,
    boilerplate: true,
    search: "",
    singleSelect: false,
    selected: [],
    expanded: [],
    singleExpand: false,
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: "編號",
        value: "storeId",
        width: "6%",
        sortable: false,
        align: "center",
      },
      {
        text: "商店編號",
        align: "start",
        sortable: true,
        value: "storeNo",
      },
      {
        text: "編輯",
        value: "actionsEdit",
        sortable: false,
        align: "center",
        width: "6%",
      },
      {
        text: "刪除",
        value: "actionsDel",
        sortable: false,
        align: "center",
        width: "6%",
      },
    ],
    desserts: [],
    editedIndex: -1,
    defaultItem: {},
    template: {},
    transitioned: [],
    closeTimeouts: {},
    storeInfo: null,
    storeFetchTimeout: null,
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "新增" : "編輯";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
      if (val && this.template.storeNo) {
        this.fetchStoreInfo(this.template.storeNo);
      }
      if (!val) {
        this.storeInfo = null; // 關閉彈窗時清除預覽
      }
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    singleExpand(v) {
      if (!v) return;
      // Single expand enabled. Hide all but the first expanded item
      this.expanded.forEach((item, i) => {
        if (i > 0) this.closeExpand(item);
      });
    },
  },

  created() {
    // this.initialize();
    this.$bus.$emit("sideBarSelectedItem:push", 4);
    this.getStoreList();
  },

  methods: {
    initialize() {
      this.desserts = [];
    },
    async getStoreList() {
      const querySnapshot = await getDocs(collection(db, "exploreStoreList"));
      let storeNos = [];

      querySnapshot.forEach((doc) => {
        const data = doc.data();
        if (Array.isArray(data.exploreStoreList)) {
          storeNos = data.exploreStoreList;
        }
      });

      this.desserts = storeNos.map((storeNo, index) => ({
        storeNo,
        storeId: index,
      }));
    },
    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.template = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.template = Object.assign({}, item);
      this.dialogDelete = true;
    },
    async deleteItemConfirm() {
      const docRef = doc(db, "exploreStoreList", "exploreStoreList");

      await updateDoc(docRef, {
        exploreStoreList: arrayRemove(this.template.storeNo),
      });
      this.desserts = [];
      this.getStoreList();
      this.$snackbar.add(`修改完成`, { color: "success" });
      this.closeDelete();
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.template = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.$refs.form.reset();
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.template = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async save() {
      if (this.$refs.form.validate()) {
        // 新增或修改都要檢查 storeInfo 是否存在
        if (!this.storeInfo || Object.keys(this.storeInfo).length === 0) {
          this.$snackbar.add("找不到商店資料，請確認商店編號是否正確！", {
            color: "error",
          });
          return; // 阻止新增或修改
        }

        const docRef = doc(db, "exploreStoreList", "exploreStoreList");
        const docSnap = await getDoc(docRef);
        const data = docSnap.exists()
          ? docSnap.data()
          : { exploreStoreList: [] };
        const storeList = data.exploreStoreList || [];

        if (this.editedIndex > -1) {
          // 編輯已有資料
          if (
            this.template.storeId >= 0 &&
            this.template.storeId < storeList.length
          ) {
            storeList[this.template.storeId] = this.template.storeNo;

            await setDoc(docRef, {
              exploreStoreList: storeList,
            });
            await this.getStoreList();
          }
        } else {
          // 新增前判斷數量是否超過10
          if (storeList.length >= 10) {
            this.$snackbar.add("最多只能新增10筆資料喔！", { color: "error" });
            return;
          }

          await updateDoc(docRef, {
            exploreStoreList: arrayUnion(this.template.storeNo),
          });
        }

        this.desserts = [];
        this.getStoreList();
        this.$snackbar.add(`修改完成`, { color: "success" });
        this.close();
      }
    },
    debouncedFetchStoreInfo() {
      clearTimeout(this.storeFetchTimeout);
      if (!this.template.storeNo) {
        this.storeInfo = null;
        return;
      }

      this.storeFetchTimeout = setTimeout(() => {
        this.fetchStoreInfo(this.template.storeNo);
      }, 500); // 延遲 500ms
    },

    async fetchStoreInfo(storeNo) {
      this.storeInfo = null; // 清除舊資料
      const storesRef = collection(db, "stores");
      const q = query(storesRef, where("storeNo", "==", storeNo));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        // 假設只會有一筆符合
        this.storeInfo = querySnapshot.docs[0].data();
      } else {
        this.storeInfo = null;
      }
    },
  },
};
</script>
<style></style>
